'use client';

import { Box, css, HStack } from '@terra/ui-styled-system';
import { ArrowRight01Icon } from '@terra/ui-icons';
import { forwardRef } from 'react';
import { Text } from '../../../components/styled/text';
import type { ChatMentionsMenuItemType } from './types';

const menuItemStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 'full',
  cursor: 'pointer',
  userSelect: 'none',
  '&[data-active=true]': {
    bg: 'bg.subtle',
    color: 'fg.default',
  },
  '&[data-selected=true]': {
    bg: 'bg.muted',
    color: 'fg.default',
  },
  '&:hover': {
    bg: 'bg.subtle',
  },
});
const iconContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '12px',
  height: '12px',
  color: 'fg.muted',
});

export const ChatMentionsMenuItem = forwardRef<
  HTMLDivElement,
  {
    item: ChatMentionsMenuItemType;
    isSelected: boolean;
    isActive: boolean;
    onClick: () => void;
    onMouseEnter: () => void;
    'data-item-index'?: number;
    mode: 'compact' | 'default';
  }
>(
  (
    {
      item,
      isSelected,
      isActive,
      onClick,
      onMouseEnter,
      mode: _mode,
      ...props
    },
    ref,
  ) => {
    const hasSubmenu =
      (item.children && item.children.length > 0) || item.hasSubmenu;

    return (
      <Box
        ref={ref}
        className={menuItemStyles}
        py="1.5"
        px="2"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        role="option"
        aria-selected={isSelected}
        tabIndex={-1}
        data-selected={isSelected}
        data-active={isActive}
        id={`item-${item.id}`}
        {...props}
      >
        <HStack gap="2" alignItems="center" minWidth={0} flex={1}>
          {item.icon && <Box className={iconContainerStyles}>{item.icon}</Box>}
          <Text
            fontSize="xs"
            fontWeight={item.type === 'parent' ? 'medium' : 'normal'}
            color="fg.default"
            truncate
          >
            {item.label}
          </Text>
        </HStack>
        {hasSubmenu && (
          <Box flexShrink={0} color="fg.muted" ml="2">
            <ArrowRight01Icon size={12} />
          </Box>
        )}
      </Box>
    );
  },
);
ChatMentionsMenuItem.displayName = 'ChatMentionsMenuItem';
